import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Pagination} from '../../shared/Models/Pagination';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class SubProductService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public reArangeproduct(products) {
    for (const item in products.data) {
      if (products.data.hasOwnProperty(item)) {
        products.data[item].name = products.data[item].productItem.name;
        products.data[item].status = products.data[item].productItem.status;
      }
    }
    return products;
  }
  public getModals() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/model/model_items' )
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getSubProduct(gridData = new HttpParams(), params = new HttpParams()) {
    const p = [gridData.toString(), params.toString()].join('&');
    return this.http.get<Pagination<any>>(environment.apiUrl + '/backoffice/sub-product/?' + p)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getSubProductItem(productId) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/sub-product/' + productId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getInputType() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/package/input-types' )
      .pipe(catchError(res => this.helper.catchError(res)));
  }
  public manageProduct(subProduct, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/sub-product/' + id, subProduct)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/sub-product/', subProduct)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
  public manageSubProduct(subProduct, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/sub-product/' + id, subProduct)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/sub-product/', subProduct)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

}
